<template>
  <div id="screen1" v-if="$auth.isAuthenticated" class="slds-var-p-around_small">
    <notifications group="success" />
    <div class="slds-page-header slds-page-header_record-home">
		<div class="slds-page-header__row">
			<div class="slds-page-header__col-title">
				<div class="slds-media">
          <div class="slds-media__figure">
            <span class="slds-icon_container slds-icon-standard-opportunity">
              <svg class="slds-icon slds-page-header__icon" aria-hidden="true">
                <use xlink:href="/assets/icons/custom-sprite/svg/symbols.svg#custom102"></use>
              </svg>
            </span>
          </div>
          <div class="slds-media__body">
            <h2 class="slds-card__header-title">
              <a href="javascript:void(0);" class="slds-card__header-link slds-truncate" title="Accounts">
              <span style="left: 74px !important;">Dashboard</span>
              </a>
            </h2>
          </div>  
				</div>
			</div>
			<div class="slds-page-header__col-actions">
				<div class="slds-page-header__controls">
					<div class="slds-page-header__control">
						<ul class="slds-button-group-list">
							<li>
								<button variant="primary" class="slds-button slds-button_neutral" v-on:click="showDashboardPopup()">New</button>
							</li>
            </ul>
					</div>
				</div>
			</div>
		</div>
	</div>
  <div class="slds-card slds-m-top_large">
      <div class="slds-card__body slds-card__body_inner">
        <table class="slds-table slds-table_cell-buffer slds-no-row-hover slds-table_bordered slds-m-top_large slds-table_striped slds-table_col-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Segments</th>

              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in dashboardData" :key="data.id">
              <td>
                <router-link :to="{ name: 'Segments', params: { dashboardData:data }}" 
                    v-slot="{ href, route, navigate}" v-if="$auth.isAuthenticated">
                      <a :href="href" @click="navigate">
                        <span>{{data.name}}</span>
                      </a>
                    </router-link>
              </td>
              <td>{{data.segments}}</td>
              <td>
                <div class="slds-no-flex">
                    <button class="slds-button slds-button_icon slds-button_first slds-button_icon-border-filled" @click="showDashboardEditPopup(data)">
                      <svg class="slds-button__icon" aria-hidden="true">
                        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#edit"></use>
                      </svg>
                      <span class="slds-assistive-text">Edit</span>
                    </button>
                    <button @click="editDeletepopup(data.id)" class="slds-button slds-button_icon slds-button_last slds-button_icon-border-filled slds-button_icon-error" 
                    v-bind:name="data.id">
                      <svg class="slds-button__icon" aria-hidden="true">
                        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#delete"></use>
                      </svg>
                      <span class="slds-assistive-text">Delete</span>
                    </button>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--Dashboard Popup-->
    <div v-show="showPopup">
      <section role="dialog" tabindex="-1" class="slds-modal slds-fade-in-open slds-modal_medium" aria-labelledby="modal-heading-01" aria-modal="true" aria-describedby="modal-content-id-1">
        <div class="slds-modal__container">
          <header class="slds-modal__header">
            <button class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Close"  v-on:click="closeDashboardPopup()">
              <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
              </svg>
              <span class="slds-assistive-text">Close</span>
            </button>
            <h2 id="modal-heading-01" class="slds-modal__title slds-hyphenate">{{dashboardHeader}}</h2>
          </header>
          <div class="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
            <div class="slds-form--stacked">
              <form @submit.prevent="createDashboard">
                <div class="slds-form-element">
                    <label class="slds-form-element__label" for="name">Name</label>
                    <div class="slds-form-element__control">
                      <input v-model="name" id="name" class="slds-input" type="text" placeholder="Name" />
                    </div>
                </div>
                <div class="slds-form-element">
                  <label class="slds-form-element__label" for="title">Title</label>
                  <div class="slds-form-element__control">
                    <input v-model="title"  id="title" class="slds-input" type="text" placeholder="Title" />
                  </div>
                </div>
                <div class="slds-form-element">
                  <label class="slds-form-element__label" for="description">Description</label>
                  <div class="slds-form-element__control">
                    <input v-model="description"  id="description" class="slds-input" type="text" placeholder="Description" />
                  </div>
                </div>
              </form>
            </div>
            <br/>
          </div>
          <footer class="slds-modal__footer">
            <button class="slds-button slds-button_neutral"  v-on:click="closeDashboardPopup()">Cancel</button>
            
							<button class="slds-button slds-button_brand"  v-on:click="createDashboard()">Save</button>
						
          </footer>
        </div>
      </section>
      <div class="slds-backdrop slds-backdrop_open"></div>
  </div>

  <!--Delete prompt-->
    <div v-show="showConfirmDeletePopup">
      <div class="demo-only" style="height:24rem">
        <section role="alertdialog" tabindex="0" aria-labelledby="prompt-heading-id" aria-describedby="prompt-message-wrapper" class="slds-modal slds-fade-in-open slds-modal_prompt" aria-modal="true">
          <div class="slds-modal__container">
            <header class="slds-modal__header slds-theme_error slds-theme_alert-texture">
              <button class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Close">
                <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
                </svg>
                <span class="slds-assistive-text">Close</span>
              </button>
              <h2 class="slds-text-heading_medium" id="prompt-heading-id">Delete Dashboard</h2>
            </header>
            <div class="slds-modal__content slds-p-around_medium" id="prompt-message-wrapper">
              <notifications group="delete" />
              <p><center>Are you sure you want to delete this dashboard?</center></p>
            </div>
            <footer class="slds-modal__footer slds-theme_default">
              <button class="slds-button slds-button_brand" @click="deleteDashboard()">Okay</button>
              <button class="slds-button slds-button_neutral" @click="closeDeletePopup()">Cancel</button>
            </footer>
          </div>
        </section>
        <div class="slds-backdrop slds-backdrop_open"></div>
      </div>
    </div>
    <!--delete popup end--> 
  </div>
</template>

<script>
import {getDashboardUrl,createDashboardUrl, deleteDashboardUrl} from '../config';

export default {
  name: "screen1",
		
		data() {
			return {
        showPopup:false,
        showElementPopup:false,
        dashboardData:[],
        id: '',
        name: '',
        title: '',
        description: '',
        showEditPopup:false,
        dasboardIdtoDelete:'',
        showConfirmDeletePopup:false,
        dashboardHeader:'Add Dashboard'

			}
    },
    created: function() {
      this.getDashboardData();
    },
    methods: {
      getDashboardData: function () {
        this.dasboardIdtoDelete = '';
        this.dasboardIdtoEdit = '';
        this.axios.get(getDashboardUrl)
				.then((response) => {
					this.dashboardData = JSON.parse(JSON.stringify(response.data));
				}).catch((error => {
					// eslint-disable-next-line no-console
					console.log(error);            
				}))
      },
      createDashboard: function () {
        let dashboard = {
          name: this.name,
          title: this.title,
          description: this.description,
          id: this.id
        }
      
        console.log('idd'+JSON.stringify(dashboard));
        this.axios.post(createDashboardUrl, dashboard)
          .then((response) => {
              this.showPopup=false
              if(this.id > 0){
                this.$notify({
                  group: 'success', type: 'success', duration: 2000,
                  title: 'Details udpated!',
                  text: 'Dashboard ' + this.name + ' updated successfully.'
                });      
              }else{
                this.$notify({
                  group: 'success', type: 'success', duration: 2000,
                  title: 'Details udpated!',
                  text: 'Dashboard added successfully.'
                });      
              }
              
              
              console.log(response);
              this.getDashboardData();
            }).catch((error => {
              if(error.response.status == 401){
                this.$notify({
                  group: 'success', type: 'warning', duration: 1000,
                  title: 'Warning!',
                  text: 'Unable to update availability.'
                });
              }            
				}))  
      },
      editDeletepopup: function (dashboardId){
        console.log('deleteId'+dashboardId);
        this.dasboardIdtoDelete = dashboardId;
        this.showConfirmDeletePopup = true;
      },
      closeDeletePopup : function (){
        this.dasboardIdtoDelete = '';
        this.showConfirmDeletePopup = false;
      },
      deleteDashboard: function (){
        console.log('deleteId22'+this.dasboardIdtoDelete);
        this.axios.post(deleteDashboardUrl + this.dasboardIdtoDelete)
            .then((response) => {
              console.log(response);
              this.$notify({
                group: 'success', type: 'success', duration: 1000,
                title: 'Dashboard data deleted!',
                text: 'Dashboard data deleted successfully.'
              });
              this.showConfirmDeletePopup = false;
              this.getDashboardData();
              
            }).catch((error => {
               
                this.$notify({
                group: 'delete', type: 'warning', duration: 1000,
                title: 'Warning!',
                text: error
              });
              this.showConfirmDeletePopup = false;
          }))
      },
      showDashboardPopup: function () {
        this.showPopup=true;
        this.dashboardHeader = 'Add Dashboard';
        this.resetDashboardData();
      },
      closeDashboardPopup: function () {
        this.showPopup=false;
        this.resetDashboardData();
      },
      showDashboardEditPopup: function(data){
        this.dashboardHeader = 'Edit Dashboard';
        this.showPopup=true;
        this.id = data.id;
        this.name = data.name;
        this.title = data.title;
        this.description = data.description;
      },
      resetDashboardData: function(){
        this.name ='';
        this.title = '';
        this.description = '';
        this.id = '';
      }
    }
}
</script>
